import React, { useState,useEffect,useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import './Communication.css';
import { Util } from '../../../config/Util';

function AddCommunication(arg) {
  const [show, setShow] = useState(arg.flag);
  const [title,setTitle] = useState("");
  const [desc,setDesc] = useState("");
  const [file,setFile] = useState('');
  const [fileType, setFileType] = useState('');
  const [expiryDate, setExpiryDate] = useState(new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
  const [todayDate, setTodayDate] = useState(new Date());
  const [isAnnouncement, setIsAnnouncement] = useState(false);
  const checkFlag = useRef(0);


  useEffect(() => {
    if(arg.edit){
        const data = arg.data;
        setTitle(data.name);
        setDesc(data.description);
        setFileType(data.mediaType);
        setIsAnnouncement(data.isAnnouncement);
    }
  },[]);

  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);
  const handleTitleInput=(e)=>{
    setTitle(e.target.value);
  }
  const handleDescInput=(e)=>{
    setDesc(e.target.value);
  }
  const handleFileInput=(e)=>{
    setFile(e.target.files[0]);
  }
  const saveCommunication=() =>{
    setShow(false);
    const req = {
      name : title ,
      description: desc,
      mediaType : fileType,
      isAnnouncement : isAnnouncement,
      validfrom :todayDate.toISOString().split('T')[0],
      validto: expiryDate.toISOString().split('T')[0],
      file
    }
    console.log(req);
    arg.callback(req);
  }
  const editCommunication=()=>{
    setShow(false);
    const req = {
      id: arg.data.id,
      name : title ,
      description: desc,
      mediaType : fileType,
      isAnnouncement : isAnnouncement,
      validfrom :arg.data.validfrom,
      validto: expiryDate.toISOString().split('T')[0]
    }
    if(checkFlag.current === 0){
      req.validto = arg.data.validto;
    }
    if(file){
      req.file = file;
    }
    arg.callback(req);
  }

  const getAcceptedType=()=>{
    if(fileType == 'pdf'){
      return '.pdf';
    }else if(fileType == 'image'){
      return '.jpg,.jpeg,.png';
    }else if(fileType == 'video'){
      return '.mp4,.mov,.avi,.wmv,.mkv';
    }
    return '.nofile';
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>{arg.edit ? "Edit Communication" : "Add New Communication"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text" value={title} onChange={handleTitleInput}
                
                autoFocus
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={2} value={desc} onChange={handleDescInput}/>
            </Form.Group>
            <Form.Group
              className="mb-3">
              <Form.Label>Media Type</Form.Label>
              <select className='form-control'  onChange={(e)=>setFileType(e.target.value)} value={fileType} >
                <option></option>
                <option value='pdf'>PDF</option>
                <option value='image'>Image</option>
                <option value='video'>Video</option>
              </select>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Expiry Date</Form.Label>
              <DatePicker dateFormat="yyyy/MM/dd" minDate={todayDate} selected={(arg.edit && checkFlag.current===0)?new Date(arg.data.validto):expiryDate} onChange={(date) =>{ checkFlag.current=1; setExpiryDate(date)}} className='form-control'/>
            </Form.Group>

            <Form.Group className="mb-3 announDiv" controlId="announceElem">
             
              <Form.Check
                type="checkbox" value={isAnnouncement} onChange={(e)=>setIsAnnouncement(e.target.checked)} checked={isAnnouncement}/>
                <span className='ml-3'>Is Announcement?</span>
            </Form.Group> 
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Upload File</Form.Label>
              <Form.Label>{
                (arg.edit && file==='') ? <a href={Util.baseURlForDownload + arg.data.file} download>-Download File</a>
                :''
              }</Form.Label>
              <Form.Control type="file" className='form-control' onChange={handleFileInput} accept={getAcceptedType()} />
              
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
          {arg.edit ? <Button variant="primary" onClick={editCommunication}>
            EDIT
          </Button>
          : <Button variant="primary" onClick={saveCommunication}>
          SAVE
        </Button>}
          
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddCommunication;

